import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import incomeAmount from "../../../assets/icons/income-amount.svg";
import { useGetBussinessData } from "../../../lib/queries/queriesAndMutations";
import SettelemntSettingForm from "../../forms/SettelemntSettingForm";
import BusinessBalance from "../../shared/BusinessBalance";
import Loader from "../../shared/Loader";
import MoneyCard from "../../shared/MoneyCard";
import Statistics from "../../shared/Statistics ";

const BussinessDashboard = () => {
  const dispatch = useDispatch();
  const { type, id } = useParams();

  const { refetch, isRefetching } = useGetBussinessData({ type, id, dispatch });

  useEffect(() => {
    refetch();
  }, [type, id, dispatch, refetch]);

  const bussinessData = useSelector((store) => store.bussinessSlice.data);

  const summaryData = useSelector((store) => store.bussinessSlice.summaryData);

  if (isRefetching) {
    return (
      <div className="w-full h-full flex-center">
        <Loader />
      </div>
    );
  }

  return (
    <div className="w-full rounded-v-lg  mb-2  p-2 flex flex-col gap-6">
      <div className=" w-full   flex-col md:gap-4 pt-4">
        <div className="w-full grid grid-cols-2  gap-4  md:p-4 ">
          <MoneyCard img={incomeAmount} title={" تسویه 30 روز گذشته"} text={summaryData?.settlement_total} />
          <MoneyCard img={incomeAmount} title={" درآمد 30 روز گذشته"} text={summaryData?.transaction_total} />
        </div>
        <div className="flex w-full gap-2   md:p-2  mt-4 md:mt-0 ">
          <div className="flex-1  hidden md:inline-block ">
            <Statistics type={type} id={id} />
          </div>

          <BusinessBalance type={type} id={id} />
        </div>

        <SettelemntSettingForm data={bussinessData.wallet} type={type} id={id} />
      </div>
    </div>
  );
};

export default BussinessDashboard;
